import { render } from "./UsrAmend.vue?vue&type=template&id=ec8c0fcc"
import script from "./UsrAmend.vue?vue&type=script&lang=js"
export * from "./UsrAmend.vue?vue&type=script&lang=js"

import "./UsrAmend.vue?vue&type=style&index=0&id=ec8c0fcc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__